import React, {
    useCallback,
    useEffect,
    useRef,
    useState
} from 'react';
import { useSelector, useDispatch } from 'react-redux';


import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import api from '~/services/api';
import qs from 'querystring';
import { format } from 'date-fns';
import { t, parseDateString } from '~/helpers'



import { Input, RadioGroup, DateTime } from '~/components/Form';
import * as S from './styles'

import { updateEletronica } from '~/store/modules/equipamento/actions';


import { Accordion, AccordionSummary, Typography, Divider } from '@material-ui/core';
import { isEmpty } from 'lodash';

export default function EquipamentoEletronica({
    data,
    sending,
    visible,
    toggleDisabled,
    close
}) {

    const dispatch = useDispatch()

    const reduxData = useSelector(state => state.equipamento)
    const formRef = useRef(null);

    const [cleanTransponder1, setCleanTransponder1] = useState(false)
    const [cleanTransponder2, setCleanTransponder2] = useState(false)
    const [dataEletronica, setDataEletronica] = useState({})

    useEffect(() => {
        if (!isEmpty(data)) {
            handleGetDataEletronica(data)
        }
    }, [data])

    const handleGetDataEletronica = useCallback(async (dataElet) => {
        const { veic_cod_veic, empe_cod_emp } = dataElet

        const params = {
            wherefield: ['veic_cod_veic', 'empe_cod_emp'],
            valuewherefield: [veic_cod_veic, empe_cod_emp],
            typewherefield: ['EQUALS', 'EQUALS']
        }
        const response = await api.get('veiculoeletronica', {
            params,
            paramsSerializer: (param) => qs.stringify(param),
        });

        if (!isEmpty(response.data.items[0])) {
            setDataEletronica(response.data.items[0])
        }
    }, [])


    const handleSubmit = useCallback(async (param) => {
        try {
            toggleDisabled(true)
            const schema = Yup.object().shape({
                veel_ver_bocal: Yup.number()
                    .typeError('Campo obrigatório')
                    .required('Campo obrigatório')
                    .min(0, 'O valor deve ser maior que 0')
                    .max(9999, 'Valor máximo 9999'),
                veel_datainstalacao_bocal: Yup.date()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .transform((_, value) => parseDateString(value))
                    .required(t('s.geral.validacao.campoobrigatorio')),
                veel_datainstalacao_dloc: Yup.date()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .transform((_, value) => parseDateString(value))
                    .required(t('s.geral.validacao.campoobrigatorio')),
                veel_datainstalacao_medidor: Yup.date()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .transform((_, value) => parseDateString(value))
                    .required(t('s.geral.validacao.campoobrigatorio')),
                veel_datainstalacao_overfill: Yup.date()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .transform((_, value) => parseDateString(value))
                    .required(t('s.geral.validacao.campoobrigatorio')),
                veel_dataatulizacao_bocal: Yup.date()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .transform((_, value) => parseDateString(value))
                    .required(t('s.geral.validacao.campoobrigatorio')),
                veel_dataatulizacao_dloc: Yup.date()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .transform((_, value) => parseDateString(value))
                    .required(t('s.geral.validacao.campoobrigatorio')),
                veel_dataatulizacao_medidor: Yup.date()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .transform((_, value) => parseDateString(value))
                    .required(t('s.geral.validacao.campoobrigatorio')),
                veel_dataatulizacao_overfill: Yup.date()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .transform((_, value) => parseDateString(value))
                    .required(t('s.geral.validacao.campoobrigatorio')),
            });

            await schema.validate(param, {
                abortEarly: false,
            });

            const objSend = {
                codVeiculo: data.veic_cod_veic,
                codEmpresa: data.empe_cod_emp,
                transponder01: param.veic_transponder1 ?? '',
                transponder02: param.veic_transponder2 ?? '',
                veel_tem_a2vf: Number(param.veel_tem_a2vf),
                veel_tem_dloc: Number(param.veel_tem_dloc),
                veel_tem_overfill: Number(param.veel_tem_overfill),
                veel_ver_bocal: Number(param.veel_ver_bocal),
                veel_vol_tanque_auto: Number(param.veel_vol_tanque_auto),
                veel_tem_medidor_volumetrico: Number(param.veel_tem_medidor_volumetrico),
                veel_conectado_autotrac: Number(dataEletronica.veel_conectado_autotrac),
                veel_datainstalacao_bocal: param.veel_datainstalacao_bocal,
                veel_datainstalacao_dloc: param.veel_datainstalacao_dloc,
                veel_datainstalacao_medidor: param.veel_datainstalacao_medidor,
                veel_datainstalacao_overfill: param.veel_datainstalacao_overfill,
                veel_dataatulizacao_bocal: param.veel_dataatulizacao_bocal,
                veel_dataatulizacao_dloc: param.veel_dataatulizacao_dloc,
                veel_dataatulizacao_medidor: param.veel_dataatulizacao_medidor,
                veel_dataatulizacao_overfill: param.veel_dataatulizacao_overfill,
                veau_def_overfill: Number(param.veau_def_overfill)
            }

            await dispatch(updateEletronica(objSend, reduxData.params))
            toggleDisabled(false)
            close()
        } catch (err) {
            toggleDisabled(false)
            const validationErrors = {};
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message.replace(
                        `${error.path} `,
                        ''
                    );
                });
                formRef.current.setErrors(validationErrors);
            } else {
                toast.error(err)
            }
        }

    }, [formRef, reduxData, data, dataEletronica])

    useEffect(() => {
        if (sending) formRef.current.submitForm();
    }, [sending]);

    return (
        <>
            {!isEmpty(dataEletronica) &&
                <S.ModalForm
                    ref={formRef}
                    initialData={{
                        ...data,
                        ...dataEletronica,
                        veel_tem_a2vf: String(dataEletronica.veel_tem_a2vf),
                        veel_tem_dloc: String(dataEletronica.veel_tem_dloc),
                        veel_tem_overfill: String(dataEletronica.veel_tem_overfill),
                        veel_vol_tanque_auto: String(dataEletronica.veel_vol_tanque_auto),
                        veel_tem_medidor_volumetrico: String(dataEletronica.veel_tem_medidor_volumetrico),
                        veau_def_overfill: String(dataEletronica.veau_def_overfill),
                        veel_datainstalacao_bocal: format(new Date(dataEletronica.veel_datainstalacao_bocal), 'dd/MM/yyyy HH:mm:ss'),
                        veel_datainstalacao_dloc: format(new Date(dataEletronica.veel_datainstalacao_dloc), 'dd/MM/yyyy HH:mm:ss'),
                        veel_datainstalacao_medidor: format(new Date(dataEletronica.veel_datainstalacao_medidor), 'dd/MM/yyyy HH:mm:ss'),
                        veel_datainstalacao_overfill: format(new Date(dataEletronica.veel_datainstalacao_overfill), 'dd/MM/yyyy HH:mm:ss'),
                        veel_dataatulizacao_bocal: format(new Date(dataEletronica.veel_dataatulizacao_bocal), 'dd/MM/yyyy HH:mm:ss'),
                        veel_dataatulizacao_dloc: format(new Date(dataEletronica.veel_dataatulizacao_dloc), 'dd/MM/yyyy HH:mm:ss'),
                        veel_dataatulizacao_medidor: format(new Date(dataEletronica.veel_dataatulizacao_medidor), 'dd/MM/yyyy HH:mm:ss'),
                        veel_dataatulizacao_overfill: format(new Date(dataEletronica.veel_dataatulizacao_overfill), 'dd/MM/yyyy HH:mm:ss'),
                    }}
                    onSubmit={handleSubmit} >
                    <Input name="veic_cod_veic" label="Veículo" disabled />
                    <Input name="empe_desc" label="Empresa" disabled />
                    <Accordion
                        defaultExpanded={true}
                        disabled={true}>
                        <AccordionSummary
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            disableRipple={true}
                        >
                            <S.AccordionTitle >Dados do A2VF</S.AccordionTitle>
                        </AccordionSummary>
                        <S.AccordionWrapper>
                            <S.RadioWrapper>
                                <RadioGroup
                                    name="veel_tem_a2vf"
                                    label="Tem A2VF"
                                    required
                                    options={[
                                        { label: 'Sim', value: "1" },
                                        { label: 'Não', value: "0" },
                                    ]
                                    }
                                    serialize={(value) => value}
                                    row
                                />
                                <RadioGroup
                                    name="veel_tem_dloc"
                                    label="Tem DLOC"
                                    required
                                    options={[
                                        { label: 'Sim', value: "1" },
                                        { label: 'Não', value: "0" },
                                    ]
                                    }
                                    serialize={(value) => value}
                                    row
                                />

                                <RadioGroup
                                    name="veel_tem_overfill"
                                    label="Tem OverFill"
                                    required
                                    options={[
                                        { label: 'Sim', value: "1" },
                                        { label: 'Não', value: "0" },
                                    ]
                                    }
                                    serialize={(value) => value}
                                    row
                                />
                            </S.RadioWrapper>


                            <Input name="veel_ver_bocal" label="Versão" type="number" inputProps={{ min: 0, max: 9999 }} />

                            <S.RadioWrapper>
                                <RadioGroup
                                    name="veel_vol_tanque_auto"
                                    label="Tem Volume Tanque Automático"
                                    required
                                    options={[
                                        { label: 'Sim', value: "1" },
                                        { label: 'Não', value: "0" },
                                    ]
                                    }
                                    serialize={(value) => value}
                                    row />

                                <RadioGroup
                                    name="veel_tem_medidor_volumetrico"
                                    label="Tem Medidor Volumetrico"
                                    required
                                    options={[
                                        { label: 'Sim', value: "1" },
                                        { label: 'Não', value: "0" },
                                    ]
                                    }
                                    serialize={(value) => value}
                                    row />

                            </S.RadioWrapper>
                            <S.TransponderContainer>
                                {cleanTransponder1 ? <Input name="cleantransponder01" label="Transponder 01" disabled={true} value="" />
                                    :
                                    <Input name="veic_transponder1" label="Transponder 01" disabled={true} />

                                }
                                <S.CleanButton
                                    style={{ marginTop: '8px', marginBottom: '8px', marginLeft: '5px' }}
                                    color="primary"
                                    size="small"
                                    variant="contained"
                                    onClick={() => setCleanTransponder1(true)}
                                    disabled={cleanTransponder1}
                                >
                                    Limpar
                                </S.CleanButton>
                            </S.TransponderContainer>
                            <S.TransponderContainer>
                                {cleanTransponder2 ? <Input name="cleantransponder02" label="Transponder 02" disabled={true} value="" />
                                    :

                                    <Input name="veic_transponder2" label="Transponder 02" disabled={true} />
                                }
                                <S.CleanButton
                                    style={{ marginTop: '8px', marginBottom: '8px', marginLeft: '5px' }}
                                    color="primary"
                                    size="small"
                                    variant="contained"
                                    disabled={cleanTransponder2}
                                    onClick={() => setCleanTransponder2(true)}
                                >
                                    Limpar
                                </S.CleanButton>
                            </S.TransponderContainer>

                        </S.AccordionWrapper>


                    </Accordion>

                    <Accordion
                        defaultExpanded={true}
                        disabled={true}>
                        <AccordionSummary
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            disableRipple={true}
                        >
                            <S.AccordionTitle >Data Instalação/Atualização</S.AccordionTitle>
                        </AccordionSummary>
                        <S.AccordionWrapper>
                            <Typography>Instalação</Typography>
                            <S.DateWrapper>
                                <S.DateContainer>
                                    <DateTime
                                        time
                                        name="veel_datainstalacao_bocal"
                                        label="Data Instalação Bocal"
                                        minDate={'1899-01-01'}
                                    />
                                </S.DateContainer>

                                <S.DateContainer>
                                    <DateTime
                                        time
                                        name="veel_datainstalacao_dloc"
                                        label="Data Instalação DLOC"
                                        minDate={'1899-01-01'}
                                    />
                                </S.DateContainer>

                                <S.DateContainer>
                                    <DateTime
                                        time
                                        name="veel_datainstalacao_medidor"
                                        label="Data Instalação Medidor"
                                        minDate={'1899-01-01'}
                                    />
                                </S.DateContainer>

                                <S.DateContainer>
                                    <DateTime
                                        time
                                        name="veel_datainstalacao_overfill"
                                        label="Data Instalação OverFill"
                                        minDate={'1899-01-01'}
                                    />
                                </S.DateContainer>

                            </S.DateWrapper>
                            <Divider />
                            <Typography>Atualização</Typography>
                            <S.DateWrapper>
                                <S.DateContainer>
                                    <DateTime
                                        time
                                        name="veel_dataatulizacao_bocal"
                                        label="Data Atualização Bocal"
                                        minDate={'1899-01-01'}
                                    />
                                </S.DateContainer>

                                <S.DateContainer>
                                    <DateTime
                                        time
                                        name="veel_dataatulizacao_dloc"
                                        label="Data Atualização DLOC"
                                        minDate={'1899-01-01'}
                                    />
                                </S.DateContainer>

                                <S.DateContainer>
                                    <DateTime
                                        time
                                        name="veel_dataatulizacao_medidor"
                                        label="Data Atualização Medidor"
                                        minDate={'1899-01-01'}
                                    />
                                </S.DateContainer>

                                <S.DateContainer>
                                    <DateTime
                                        time
                                        name="veel_dataatulizacao_overfill"
                                        label="Data Atualização OverFill"
                                        minDate={'1899-01-01'}
                                    />
                                </S.DateContainer>


                            </S.DateWrapper>
                        </S.AccordionWrapper>

                    </Accordion>

                    <Accordion
                        defaultExpanded={true}
                        disabled={true}>
                        <AccordionSummary
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            disableRipple={true}
                        >
                            <S.AccordionTitle >Defeitos</S.AccordionTitle>
                        </AccordionSummary>
                        <S.AccordionWrapper>
                            <S.RadioWrapper>

                                <RadioGroup
                                    name="veau_def_overfill"
                                    label="Tem defeito no OverFill"
                                    required
                                    options={[
                                        { label: 'Sim', value: "1" },
                                        { label: 'Não', value: "0" },
                                    ]
                                    }
                                    serialize={(value) => value}
                                    row
                                />
                            </S.RadioWrapper>

                        </S.AccordionWrapper>
                    </Accordion>
                </S.ModalForm >
            }

        </>


    )
}

EquipamentoEletronica.propTypes = {
    data: PropTypes.objectOf(PropTypes.any).isRequired,
    sending: PropTypes.bool.isRequired,
    visible: PropTypes.bool.isRequired,
    toggleDisabled: PropTypes.func.isRequired,
};
